module.exports = __webpack_public_path__ + "img/misc_step1.9aea2821.png";